import { Centrifuge } from "centrifuge";
import { createContext } from "react";

interface CentrifugeContextType {
  client?: Centrifuge | null;
}

const CentrifugeContext = createContext<CentrifugeContextType | null>(null);

export { CentrifugeContext };
